/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {WriteCustomerBioRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/write_customer_bio.pb'
import {WriteCustomerBioResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/write_customer_bio.pb'


export const writeCustomerBio = (request: WriteCustomerBioRequest, options?: CashRequestOptions) => post<WriteCustomerBioRequest, WriteCustomerBioResponse>("/2.0/cash/write-customer-bio", request, {...options, rejectOnError: true })